<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        {{ isEdit ? 'Editar Grupo' : 'Novo Grupo' }}
        <v-spacer></v-spacer>
        <v-btn text to="/adicionais">Voltar</v-btn>
      </v-card-title>
      
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="form.nome" label="Nome do Grupo" required :rules="[v => !!v || 'Nome obrigatório']"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
               <v-select 
                  v-model="form.tipo" 
                  :items="['OPCIONAL', 'OBRIGATORIO']" 
                  label="Tipo de Escolha"
               ></v-select>
            </v-col>
            <v-col cols="6" md="1">
              <v-text-field v-model.number="form.min" type="number" label="Mín"></v-text-field>
            </v-col>
             <v-col cols="6" md="2">
              <v-text-field v-model.number="form.max" type="number" label="Max"></v-text-field>
            </v-col>
             <v-col cols="12" md="12">
              <v-text-field v-model.number="form.ordem" type="number" label="Ordem de Exibição"></v-text-field>
            </v-col>
          </v-row>
          
          <v-btn color="primary" @click="saveGroup" :disabled="!valid" :loading="saving">Salvar Grupo</v-btn>
        </v-form>
      </v-card-text>

      <!-- ITENS SECTION (Only if Edit) -->
      <v-divider v-if="isEdit" class="my-4"></v-divider>
      
      <v-card-text v-if="isEdit">
          <div class="d-flex align-center justify-space-between mb-4">
              <h3>Itens do Grupo</h3>
              <v-btn color="secondary" small @click="openItemModal()">Adicionar Item</v-btn>
          </div>
          
          <v-data-table
            :headers="itemHeaders"
            :items="items"
            hide-default-footer
          >
             <template v-slot:item.valor="{ item }">
                 R$ {{ item.valor.toFixed(2).replace('.', ',') }}
             </template>
              <template v-slot:item.actions="{ item }">
                  <v-btn icon small @click="openItemModal(item)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon small color="red" @click="deleteItem(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
             </template>
          </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Modal Item -->
    <v-dialog v-model="itemModal" max-width="500px">
        <v-card>
            <v-card-title>{{ editingItem ? 'Editar Item' : 'Novo Item' }}</v-card-title>
            <v-card-text>
                <v-form ref="itemForm">
                    <v-text-field v-model="itemForm.nome" label="Nome do Item"></v-text-field>
                    <v-text-field v-model.number="itemForm.valor" label="Valor Adicional (R$)" type="number" step="0.01"></v-text-field>
                    <v-text-field v-model.number="itemForm.ordem" label="Ordem"></v-text-field>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="itemModal = false">Cancelar</v-btn>
                <v-btn color="primary" @click="saveItem">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- Dialog de Confirmação Deletar Item -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline">Excluir Item</v-card-title>
        <v-card-text>Tem certeza que deseja remover o item <strong>{{ itemToDelete ? itemToDelete.nome : '' }}</strong>?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="confirmDeleteItem">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AddonsCreate',
  data() {
    return {
      valid: false,
      saving: false,
      dialogDelete: false,
      itemToDelete: null,
      form: {
        nome: '',
        tipo: 'OPCIONAL',
        min: 0,
        max: 1,
        ordem: 0
      },
      items: [],
      itemHeaders: [
          { text: 'Nome', value: 'nome' },
          { text: 'Valor (+)', value: 'valor' },
          { text: 'Ordem', value: 'ordem' },
          { text: 'Ações', value: 'actions', sortable: false }
      ],
      
      // Item Modal
      itemModal: false,
      editingItem: null,
      itemForm: {
          nome: '',
          valor: 0,
          ordem: 0
      }
    };
  },
  computed: {
      isEdit() {
          return !!this.$route.params.id;
      },
      id() {
          return this.$route.params.id;
      }
  },
  created() {
      if (this.isEdit) {
          this.fetchGroup();
      }
  },
  methods: {
    async fetchGroup() {
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_LOCAL}/grupos-adicionais`);
            // The API returns all groups. We filter locally or should have getGroupById endpoint.
            // For now filtering from getAll to save time implementing getById on controller if not exists.
            // Wait, controller has getGroups (all). Doesn't have getGroupById specific.
            const group = res.data.find(g => g.ID == this.id);
            if (group) {
                this.form = {
                    nome: group.NOME,
                    tipo: group.TIPO_ESCOLHA,
                    min: group.QTD_MIN,
                    max: group.QTD_MAX,
                    ordem: group.ORDEM
                };
                this.items = group.itens; // Controller returns nested items
            }
        } catch (error) {
            console.error(error);
        }
    },
    async saveGroup() {
        this.saving = true;
        try {
            if (this.isEdit) {
                await axios.put(`${process.env.VUE_APP_API_LOCAL}/grupos-adicionais/${this.id}`, this.form);
            } else {
                const res = await axios.post(`${process.env.VUE_APP_API_LOCAL}/grupos-adicionais`, this.form);
                this.$router.push(`/adicionais/editar/${res.data.id}`);
            }
             this.$root.$emit('open-snackbar-on-group', 'Grupo salvo com sucesso!');
        } catch (error) {
            console.error(error);
             this.$root.$emit('open-snackbar-on-group', 'Erro ao salvar grupo');
        } finally {
            this.saving = false;
        }
    },
    
    // Items
    openItemModal(item = null) {
        this.editingItem = item;
        if (item) {
            this.itemForm = { ...item };
        } else {
            this.itemForm = { nome: '', valor: 0, ordem: 0 };
        }
        this.itemModal = true;
    },
    async saveItem() {
        try {
            if (this.editingItem) {
                await axios.put(`${process.env.VUE_APP_API_LOCAL}/adicionais/${this.editingItem.id}`, this.itemForm);
            } else {
                await axios.post(`${process.env.VUE_APP_API_LOCAL}/grupos-adicionais/${this.id}/itens`, this.itemForm);
            }
            this.itemModal = false;
            this.fetchGroup(); // Refresh
        } catch (error) {
            console.error(error);
             this.$root.$emit('open-snackbar-on-group', 'Erro ao salvar item');
        }
    },
    
    deleteItem(item) {
        this.itemToDelete = item;
        this.dialogDelete = true;
    },

    closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
            this.itemToDelete = null;
        });
    },

    async confirmDeleteItem() {
        if (!this.itemToDelete) return;
        
        try {
            await axios.delete(`${process.env.VUE_APP_API_LOCAL}/adicionais/${this.itemToDelete.id}`);
            this.fetchGroup();
            this.$root.$emit('open-snackbar-on-group', 'Item removido com sucesso');
        } catch (error) {
            console.error(error);
             this.$root.$emit('open-snackbar-on-group', 'Erro ao remover item');
        } finally {
            this.closeDelete();
        }
    }
  }
};
</script>
